var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoDetails = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_Details",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_47475",
    "data-name": "Path 47475",
    d: "M8,0a8,8,0,1,0,8,8A8.009,8.009,0,0,0,8,0ZM8,14.545A6.545,6.545,0,1,1,14.545,8,6.553,6.553,0,0,1,8,14.545Z",
    fill: "#999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47476",
    "data-name": "Path 47476",
    d: "M146.127,70a1.125,1.125,0,1,0,1.125,1.126A1.126,1.126,0,0,0,146.127,70Z",
    transform: "translate(-138.127 -66.682)",
    fill: "#999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47477",
    "data-name": "Path 47477",
    d: "M150.844,140a.844.844,0,0,0-.844.844v5.063a.844.844,0,0,0,1.688,0v-5.062A.844.844,0,0,0,150.844,140Z",
    transform: "translate(-142.844 -133.833)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoDetails);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_details.cfd1b3dec2c72d773e431d56f1ba3fa1.svg";